<template>
  <div>
    <div class="footer">
      <div class="content-box ">
        <div class="">
          <div class="footer-router">
            <div class="">
              <div class="menu">
                <div class="title">Company</div>
                <div class="item" @click="go(aboutus)">About Us</div>
                <div class="item" @click="go(leadership)">Leadership</div>
                <div class="item" @click="go(events)">Events</div>
                <div class="item" @click="go(career)">Career</div>
                <div class="item" @click="go(investors)">Investors</div>
              </div>
              <div class="menu">
                <div class="title">Support</div>
                <div class="item" @click="go(privacypolicy)">Privacy Policy</div>
                <div class="item" @click="go(practitioner)">Practitioner FAQ</div>
                <div class="item" @click="go(user)">User FAQ</div>
                <div class="item" @click="go(contact)">Contact Us</div>
              </div>
            </div>
          </div>
          <div class="icon-group d-flex">
            <div class="icon">
              <img src="@/assets/2.0/ins.png" />
            </div>
            <div class="icon" @click="toWeb(facebook)">
              <img src="@/assets/2.0/facebook.png" />
            </div>
            <div class="icon" @click="toWeb(twitter)">
              <img src="@/assets/2.0/twitter.png" />
            </div>
          </div>
        </div>
        <div class="footer-text">
          <p>Copyright © 2023 Smwmed Inc. All rights reserved.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerEle",
  data() {
    return {
      ins: process.env.VUE_APP_INS,
      facebook: process.env.VUE_APP_FACEBOOK,
      twitter: process.env.VUE_APP_TWITTER,
      aboutus: process.env.VUE_APP_ABOUTUS,
      leadership: process.env.VUE_APP_LEADERSHIP,
      events: process.env.VUE_APP_EVENTS,
      career: process.env.VUE_APP_CAREER,
      investors: process.env.VUE_APP_INVESTORS,
      privacypolicy: process.env.VUE_APP_PRIVACY_POLICY,
      practitioner: process.env.VUE_APP_PRACTITIONER_FAQ,
      user: process.env.VUE_APP_USER_FAQ,
      contact: process.env.VUE_APP_CONTACT_US,
    };
  },

  methods: {
    go(path) {
      console.log(path);
      this.$router.push(path)
    },
    toWeb(path){
      console.log(path);
      window.open(path)
    }
  }
};
</script>

<style lang="less" scoped>
.footer{
  background: #26488B;
  width: 100%;
  .content-box{
    padding: 0.62rem 0.92rem;
    .footer-text{
      font-size: 0.24rem;
      color: #4A69A3;
      margin-top: 0.4rem;
    }
    .footer-router{

      .menu{
        &:last-child{
          margin-top: 0.8rem;
        }

        .title{
          font-size: 0.24rem;
          font-weight: 500;
          color: #4A69A3;
          margin-bottom: 0.41rem;
        }
        .item{
          font-size: 0.24rem;
          color: #4A69A3;
          margin-bottom: 0.41rem;
          transition: all 0.2s;
          cursor: pointer;
          &:hover{
            color: #b8b4b4;
          }
        }
      }
    }
    .icon-group{
      margin-top: 0.9rem;
      .icon{
        width: 0.64rem;
        height: 0.64rem;
        margin-right: 0.1rem;
        cursor: pointer;
        img{
          width: 100%;
        }
      }
    }
  }
}
/* 桌面显示器，小于 1000px） */
@media (max-width: 1000px) {
.footer .content-box .footer-router .menu{
  margin-right: 55px;
}
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/components/footerEle.vue